import React, { useEffect, useRef, useState } from 'react'
import debounce from 'lodash.debounce'

const GooglePlacesSearch = ({
  disabled,
  addressFull,
  onAddressChange,
  onPlaceSelected,
  name = 'addressPlaces',
}) => {
  const [inputValue, setInputValue] = useState(addressFull || '')
  const [predictions, setPredictions] = useState([])
  const autocompleteServiceRef = useRef(null)
  const sessionTokenRef = useRef(null)

  useEffect(() => {
    if (window.google?.maps?.places) {
      autocompleteServiceRef.current =
        new window.google.maps.places.AutocompleteService()
      sessionTokenRef.current =
        new window.google.maps.places.AutocompleteSessionToken()
    }
  }, [])

  // Solo sincroniza el estado si `addressFull` cambia desde fuera
  useEffect(() => {
    setInputValue(addressFull || '')
  }, [addressFull])

  const fetchPredictions = useRef(
    debounce((value) => {
      if (!value || !autocompleteServiceRef.current) return

      autocompleteServiceRef.current.getPlacePredictions(
        {
          input: value,
          sessionToken: sessionTokenRef.current,
          types: ['geocode'],
          componentRestrictions: { country: 'mx' },
        },
        (results, status) => {
          if (status === window.google.maps.places.PlacesServiceStatus.OK) {
            setPredictions(results)
          } else {
            setPredictions([])
          }
        }
      )
    }, 400)
  ).current

  const handleChange = (e) => {
    const address_places = document.getElementById('address_places')
    address_places.classList.remove('is-invalid')
    const value = e.target.value
    setInputValue(value)
    fetchPredictions(value)
  }

  const handleSelectPrediction = (prediction) => {
    const description = prediction.description
    setInputValue(description)
    setPredictions([])
    onAddressChange?.(description)

    const placesService = new window.google.maps.places.PlacesService(
      document.createElement('div')
    )

    placesService.getDetails(
      {
        placeId: prediction.place_id,
        sessionToken: sessionTokenRef.current,
        fields: ['formatted_address', 'geometry', 'address_components'],
      },
      (place, status) => {
        if (status === window.google.maps.places.PlacesServiceStatus.OK) {
          onPlaceSelected?.(place)
        }
      }
    )

    sessionTokenRef.current =
      new window.google.maps.places.AutocompleteSessionToken()
  }

  return (
    <div
      className="position-relative"
      tabIndex={-1}
      onBlur={(e) => {
        if (!e.currentTarget.contains(e.relatedTarget)) {
          setPredictions([])
        }
      }}
    >
      <input
        id={name}
        name={name}
        disabled={disabled}
        type="text"
        placeholder="Escribe una dirección a buscar en mapa"
        className="form-control rounded-2 mb-3 mt-3"
        value={inputValue}
        onChange={handleChange}
        onKeyDownCapture={(e) => {
          if (e.key === 'Enter') e.preventDefault()
        }}
        autoComplete="off"
      />
      <span className="error invalid-feedback">Este campo es requerido</span>
      {predictions.length > 0 && (
        <ul
          className="list-group position-absolute w-100 z-index-9999"
          style={{ maxHeight: '200px', overflowY: 'auto' }}
        >
          {predictions.map((prediction) => (
            <li
              key={prediction.place_id}
              className="list-group-item list-group-item-action"
              onClick={() => handleSelectPrediction(prediction)}
              style={{ cursor: 'pointer' }}
            >
              {prediction.description}
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}

export default React.memo(GooglePlacesSearch)
